// import Immutable from 'seamless-immutable';
import api from "services/api";
import { createModule, constants } from "./redux-acron";
import { handlerWrapper, handlerEffects } from "../utils";
import initialState from "../utils/initialState";
/**
 * Alerts Module
 * reducer/sagas/actions
 *
 * TODO: Agregar todos los handlers y effects para los diferentes indicadores
 */
export default createModule({
  name: "social",
  modelName: "social",

  state: initialState.social,

  // ------

  handlers: {
    getFbInfo: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (payload.data) {
        const facebook = payload.data.info.data;
        const fbTotals = [
          { name: "Seguidores", data: [] },
          { name: "Publicaciones", data: [] },
          { name: "Me gusta", data: [] },
          { name: "Comentarios", data: [] },
          { name: "Compartidos", data: [] }
        ];
        const fbReactions = [
          {
            name: "Me gusta",
            data: []
          },
          {
            name: "Sorprendidos",
            data: []
          },
          {
            name: "Tristes",
            data: []
          },
          {
            name: "Enojados",
            data: []
          },
          {
            name: "Felices",
            data: []
          },
          {
            name: "Enamorados",
            data: []
          }
        ];
        const fbByUsers = [
          {
            name: "Publicaciones",
            data: []
          },
          {
            name: "Me gusta",
            data: []
          },
          {
            name: "Comentarios",
            data: []
          }
        ];
        facebook.forEach(data => {
          fbTotals[0].data = fbTotals[0].data.concat(data.size);
          fbTotals[1].data = fbTotals[1].data.concat(data.posts);
          fbTotals[2].data = fbTotals[2].data.concat(data.likes);
          fbTotals[3].data = fbTotals[3].data.concat(data.comments);
          fbTotals[4].data = fbTotals[4].data.concat(data.shares);
          fbReactions[0].data = fbReactions[0].data.concat(data.reactions_like);
          fbReactions[1].data = fbReactions[1].data.concat(data.reactions_wow);
          fbReactions[2].data = fbReactions[2].data.concat(data.reactions_sad);
          fbReactions[3].data = fbReactions[3].data.concat(
            data.reactions_angry
          );
          fbReactions[4].data = fbReactions[4].data.concat(data.reactions_haha);
          fbReactions[5].data = fbReactions[4].data.concat(data.reactions_love);
          fbByUsers[0].data = fbByUsers[0].data.concat(data.posts_by_users);
          fbByUsers[1].data = fbByUsers[1].data.concat(data.likes_by_users);
          fbByUsers[2].data = fbByUsers[2].data.concat(data.comments_by_users);
        });
        const newPayload = {
          data: {
            originalInfo: payload.data.info.data,
            fbTotals,
            fbByUsers,
            fbReactions
          }
        };

        return handlerWrapper("facebook", state, status, newPayload);
      }
      return handlerWrapper("facebook", state, status, payload);
    },
    getTwitterInfo: (state, { payload, status = constants.PENDING_STATUS }) => {
      if (payload.data) {
        const twitter = payload.data.info.data;
        const twPosts = [
          {
            name: "Publicaciones",
            data: []
          },
          {
            name: "Me gusta",
            data: []
          },
          {
            name: "Comentarios",
            data: []
          }
        ];
        const twFollowers = [
          {
            name: "Seguidores",
            data: []
          }
        ];
        twitter.forEach(data => {
          twPosts[0].data = twPosts[0].data.concat(data.posts);
          twPosts[1].data = twPosts[1].data.concat(data.likes);
          twPosts[2].data = twPosts[2].data.concat(data.replies);
          twFollowers[0].data = twFollowers[0].data.concat(data.size);
        });

        const newPayload = {
          data: {
            originalTwInfo: payload.data.info.data,
            twPosts,
            twFollowers
          }
        };
        return handlerWrapper("twitter", state, status, newPayload);
      }
      return handlerWrapper("twitter", state, status, payload);
    },
    // getSocialFollowers: (
    //   state,
    //   { payload, status = constants.PENDING_STATUS, }
    // ) => {
    //   return handlerWrapper('socialFollowers', state, status, payload)
    // },
    // updateSocialFollowers: (
    //   state,
    //   { payload, status = constants.PENDING_STATUS, }
    // ) => {
    //   if (status === constants.PENDING_STATUS) {
    //     const name = payload.name || state.followSelected
    //     const oldData = Immutable.asMutable(
    //       state.socialFollowers.filter((follow) => follow.name !== name)
    //     )
    //     const pos = state.socialFollowers.map((e) => e.name).indexOf(name)
    //     oldData.splice(pos, 0, { name, value: null, })

    //     return state.merge({
    //       followSelected    : payload.name,
    //       socialFollowers   : oldData,
    //       socialFollowersPos: pos,
    //     })
    //   }

    //   if (status === constants.SUCCESS_STATUS) {
    //     const newValue = payload.data.filter(
    //       (follow) => follow.name === state.followSelected && follow.value
    //     )
    //     const newData = Immutable.asMutable(
    //       state.socialFollowers.filter(
    //         (follow) => follow.name !== state.followSelected
    //       )
    //     )
    //     newData.splice(state.socialFollowersPos, 0, {
    //       name : state.followSelected,
    //       value: newValue[0].value,
    //     })

    //     return state.merge({
    //       socialFollowers: newData,
    //     })
    //   }
    //   return state.merge({
    //     loading: false,
    //     error  : { ...state.error, [name]: payload.data.error, },
    //   })
    // },
    // getFbTotals: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('fbTotals', state, status, payload)
    // },
    // getFbReactions: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('fbReactions', state, status, payload)
    // },
    // getFbByUsers: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('fbByUsers', state, status, payload)
    // },
    // getTwFollowers: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('twFollowers', state, status, payload)
    // },
    // getTwPosts: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('twPosts', state, status, payload)
    // },
    // getTwHashtags: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('twHashtags', state, status, payload)
    // },
    // getIgPosts: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('igPosts', state, status, payload)
    // },
    // getIgHashtags: (state, { payload, status = constants.PENDING_STATUS, }) => {
    //   return handlerWrapper('igHashtags', state, status, payload)
    // },
    // getSentimentAnalysisSocialData: (
    //   state,
    //   { payload, status = constants.PENDING_STATUS, }
    // ) => {
    //   return handlerWrapper(
    //     'sentimentAnalysisSocialData',
    //     state,
    //     status,
    //     payload
    //   )
    // },
    // getTextAnalysisSocialData: (
    //   state,
    //   { payload, status = constants.PENDING_STATUS, }
    // ) => {
    //   return handlerWrapper('textAnalysisSocialData', state, status, payload)
    // },
    setFilters: (state, { payload }) => {
      const newData = { data: [{ ...payload.filters }] };
      return state.merge({
        loading: true,
        filters: newData.data[0]
      });
    },
    clearErrors: state => {
      return state.merge({
        loading: false,
        error: []
      });
    },
    getProfileBrands: (
      state,
      { payload, status = constants.PENDING_STATUS }
    ) => {
      return handlerWrapper("profileBrands", state, status, payload);
    }
  },

  effects: {
    getFbInfo: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.socialIndicators.getFbInfo,
          payload.filters,
          actions.getFbInfo
        );
      }
    },
    getTwitterInfo: {
      callback(actions, { payload }) {
        return handlerEffects(
          api.socialIndicators.getTwitterInfo,
          payload.filters,
          actions.getTwitterInfo
        );
      }
    },
    // // Get socialFollowers indicator
    // getSocialFollowers: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.socialFollowers,
    //       payload.filters,
    //       actions.getSocialFollowers
    //     )
    //   },
    // },
    // // Update socialFollowers indicator
    // updateSocialFollowers: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.socialFollowers,
    //       { name: payload.name, filters: payload.filters, },
    //       actions.updateSocialFollowers
    //     )
    //   },
    // },
    // // Get fbTotals indicator
    // getFbTotals: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.fbTotals,
    //       payload.filters,
    //       actions.getFbTotals
    //     )
    //   },
    // },
    // // Get fbReactions indicator
    // getFbReactions: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.fbReactions,
    //       payload.filters,
    //       actions.getFbReactions
    //     )
    //   },
    // },
    // // Get fbByUser indicator
    // getFbByUsers: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.fbByUsers,
    //       payload.filters,
    //       actions.getFbByUsers
    //     )
    //   },
    // },
    // // Get twFollowers indicator
    // getTwFollowers: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.twFollowers,
    //       payload.filters,
    //       actions.getTwFollowers
    //     )
    //   },
    // },
    // // Get twPosts indicator
    // getTwPosts: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.twPosts,
    //       payload.filters,
    //       actions.getTwPosts
    //     )
    //   },
    // },
    // // Get twHashtags indicator
    // getTwHashtags: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.twHashtags,
    //       payload.filters,
    //       actions.getTwHashtags
    //     )
    //   },
    // },
    // // Get igPosts indicator
    // getIgPosts: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.igPosts,
    //       payload.filters,
    //       actions.getIgPosts
    //     )
    //   },
    // },
    // // Get igHashtags indicator
    // getIgHashtags: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.igHashtags,
    //       payload.filters,
    //       actions.getIgHashtags
    //     )
    //   },
    // },
    // // Get sentimentAnalysisSocialData indicator
    // getSentimentAnalysisSocialData: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.sentimentAnalysisSocialData,
    //       payload.filters,
    //       actions.getSentimentAnalysisSocialData
    //     )
    //   },
    // },
    // // Get textAnalysisSocialData indicator
    // getTextAnalysisSocialData: {
    //   callback(actions, { payload, }) {
    //     return handlerEffects(
    //       api.socialIndicators.textAnalysisSocialData,
    //       payload.filters,
    //       actions.getTextAnalysisSocialData
    //     )
    //   },
    // },
    // // Get Profile brands info
    getProfileBrands: {
      callback(actions) {
        return handlerEffects(
          api.referenceData.profileBrands,
          null,
          actions.getProfileBrands
        );
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/modules/SocialModule.js